import { Button, Card, Col, Row } from "antd";
import { useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";
import PopupButton from "./popupButton";
import Image from "./../../assets/images/icons/productEmpty.png";
import NoImage from "./../../assets/images/Image_not_available.png";
import { getFirstName } from "../../utils/helper.util";
import { useAppSelector } from "../../hooks/reduxHooks";

const { Meta } = Card;

const MissingSkincareComponent = ({ data, profile }: any) => {
  const userName = profile?.name?.split(" ")[0];
  const navigate = useNavigate();
    const state = useAppSelector((state) => state);
      const { userData }: { userData?: any } = state.profile;
  return (
    <>
      <section className="store-section missing_skincare-buy">
        <Card>
          <h1 className="title store-card__title">
            {getFirstName(userData?.name) ?? ""}’s Missing Skincare
          </h1>
          {data && data?.length ? (
            <Row className="buy-grid">
              {data?.map((item: any) => {
                return (
                  <Col key={item.id}>
                    <Card hoverable className="skincare-buy__card">
                      <div className="img-holder">
                        <img alt="example" src={item.image ?? NoImage} />
                        <PopupButton item={item} noImage={NoImage} />
                      </div>
                      <Meta title={item.brand_name} description={item.name} />
                    </Card>
                  </Col>
                );
              })}
            </Row>
          ) : (
            <div className="error-message">
              <img src={Image} alt="empty-product" height={100} />
              <h1>You have all the skincare. No need to buy new!</h1>
            </div>
          )}
        </Card>
      </section>
      <div className="footer-cta">
        <Button
          className="btn-primary cta-btn"
          onClick={() => {
            navigate("/store/ingredient-checker");
            ReactGA.event({
              category: "Store",
              action: `Go to Holistic Care button clicked`,
              label: "",
              nonInteraction: true, // optional, true/false
              transport: "xhr",
            });
          }}
        >
         Go to Ingredient Checker
        </Button>
      </div>
    </>
  );
};
export default MissingSkincareComponent;
